var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.999999C15 0.447715 14.5523 -5.74472e-07 14 -8.27353e-07L5 -2.65626e-08C4.44772 -3.63737e-07 4 0.447715 4 1C4 1.55228 4.44772 2 5 2L13 2L13 10C13 10.5523 13.4477 11 14 11C14.5523 11 15 10.5523 15 10L15 0.999999ZM1.70711 14.7071L14.7071 1.70711L13.2929 0.292893L0.292893 13.2929L1.70711 14.7071Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorArrow);
export default __webpack_public_path__ + "static/media/anchor-arrow.5f7a204ffb9fb55a584d6ac2a5a4a647.svg";
export { ForwardRef as ReactComponent };